<!--
 * @Descripttion: 个人会员缴费
 * @Author: zhangkaixing
 * @Date: 2022-05-17
 * @LastEditors: zhangkaixing
 * @LastEditTime: 2022-05-17 10:06:23
-->
<template>
  <div>
    <div v-if="sureSub" class="pay-con">
      <payment ref="payment"></payment>
    </div>
    <div v-else class="tip-con">
      <p class="tip">点击"确认"后，会进入缴费页面；如若您今年已经缴纳过个人会员费或所在单位已经缴纳过会费，可自行进入“报名考试”进行报名操作，无需缴费！</p>
      <el-button class="btn" type="primary" @click="submit">确认</el-button>
    </div>
  </div>
</template>

<script>
import payment from './payment'
export default {
  name: 'memberPay',
  components: { payment },
  data () {
    return {
      sureSub: false
      // sureSub: true
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    submit () {
      this.sureSub = true
    }
  }
}
</script>
<style scoped>
.tip-con {
  margin: 100px;
  text-align: center;
}
.tip-con  .tip {
  font-size: 32px;
  font-weight: 600;
}
.tip-con  .btn {
  margin-top: 20px;
}
</style>
